<template>
  <span v-if="(tratamiento.total > 0 || tratamiento.inversionTotal > 0) && esModalAplicarValido()">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <span v-if="(tratamiento.promocion === null || tratamiento.promocion === undefined)  && lista.length > 0"
          :id="'popover-promociones'+tratamiento.idPtiTratamiento" @click="visualizar()" href="#" tabindex="0">
      <em v-b-tooltip.hover.lefttop.v-light
          title="Aplicar promoción al tratamiento" class="zoom pulsate-fwd fa fa-solid fa-tag" />
    </span>
    <p v-else class="m-0 bodyTxt">{{ tratamiento.descuentoPromo | monedaEntero }}</p>

    <!--este es el tooltip-->
    <div v-if="mostrar" style="overflow-scrolling: auto">
      <template  v-for="(item,i) in lista" >
        <div class="bordePromo" :key="'p'+i" v-if="(tratamiento.total > 0 || tratamiento.inversionTotal > 0) && !item.promocionReestringida">
          <div class="col-9 centrado">
             <p class="centrado">{{item.idPromocion}}-{{item.promocion}}
               <span v-if="item.descuento>0">({{item.descuento}}%)</span>
               <span v-else>(${{item.promoDescPesos}})</span>
             </p>
          </div>
          <div class="col-3 centrado">
           <b-button v-b-tooltip.hover title="Agregar promoción" size="sm" variant="ligth-primary" @click="agregarPromocion(item, true)">
             <em class="fa fa-plus-circle"></em>
           </b-button>
          </div>
        </div>
      </template>
    </div>
  </span>
</template>
<script>
export default {
  name: "TagPromocionV5",
  props: {
    promociones: Array,
    tratamiento: Object,
   /* idEtapa: Number,*/
    totalPrioridadClinica : Number,
    montoAhorrado : Number,
    agrupadoPorOd: {
      type: Boolean,
      default: false
    }
  },
  data(){
    return {
      version: process.env.VUE_APP_ENV_VERSION,
      debug: false,
      mostrar: false,
      aux:[],
      aux1:[]
    }
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  },
  methods:{
    agregarPromocion(item, showMsj){

      if (!this.validarTrtPromoCopago()) {
        console.info("agregarPromocion-   ¡La promoción se encuentra reestringida!");
        if(showMsj) {
          this.$swal({
            position: "center",
            showConfirmButton: false,
            timer: 2500,
            toast: true,
            icon: "warning",
            title: "¡La promoción se encuentra reestringida debido a que el descuento del plan de los tratamientos es de tipo co-pago fijo!",
          })
        }
        return false;
      }


      if (!this.aplicaPromoPlan(item)) {
        console.info("agregarPromocion-   ¡La promoción se encuentra reestringida!");
        if(showMsj) {
          this.$swal({
            position: "center",
            showConfirmButton: false,
            timer: 2500,
            toast: true,
            icon: "warning",
            title: "¡La promoción se encuentra reestringida debido a que el descuento del plan supera el establecido en la configuración de la promoción!",
          })
        }
        return false;
      }

      this.tratamiento.promocion = JSON.parse(JSON.stringify(item))
      item.seleccionado = true;
      let montoDescPesosTxs = 0;
      if (this.tratamiento.tratamientos) {//en caso que sea por TX el item es la promocion
        this.tratamiento.tratamientos.forEach(t => {
          if (t.clasificacion == 1 && t.total > 0){

            t.promocion = JSON.parse(JSON.stringify(item));

            let copago = 0;
            if(t.lstCalcDesc != null && t.lstCalcDesc.length > 1 ){
              t.lstCalcDesc.forEach(trt => {
                if(trt.montoCopagoFijo != null){
                   copago += trt.montoCopagoFijo;
                }
              })
            }
            const totalPlan = t.montoDescuentoUnitarioTotal ==null?0: t.montoDescuentoUnitarioTotal;
            const totalVale = t.montoValeDescuento==null?0:t.montoValeDescuento;
            let totalOriginal = t.subtotal-(totalPlan+totalVale+copago);

            //si es promo en pesos, sino el dato ya lo trae la promo
            if (t.promocion.descuento > 0) {
              t.promocion.promoDescPesos = Math.round((totalOriginal * t.promocion.descuento) / 100);
            } else {

              if (t.promocion.promoDescPesosOriginal == null) {
                t.promocion.promoDescPesosOriginal = t.promocion.promoDescPesos;
              }
              let cantidadPromoAplica = 0;
              if(t.lstCalcDesc != null){
                t.lstCalcDesc.forEach(lcd=>{
                  if(lcd.montoDescuentoPlan == t.precioUnitario){
                    cantidadPromoAplica++;
                  }
                })
              }

              cantidadPromoAplica = t.cantidadMaxima - cantidadPromoAplica;

              t.promocion.promoDescPesos = t.promocion.promoDescPesosOriginal * cantidadPromoAplica;
              console.info("--------agregarPromocion 1: ", montoDescPesosTxs, t.promocion.promoDescPesos, t.promocion.promoDescPesosOriginal, t.cantidadMaxima);
            }

            if (t.promocion.promoDescPesos > totalOriginal) {
              t.promocion.promoDescPesos = totalOriginal;
            }

            totalOriginal -= t.promocion.promoDescPesos;

            t.total -= t.promocion.promoDescPesos;
            t.descuentoPromo = t.promocion.promoDescPesos;
            montoDescPesosTxs += t.promocion.promoDescPesos;

            this.tratamiento.total = totalOriginal;

          } else {
            // this.tratamiento.promocion = null; //Para volver a mostrar el icono
            console.info("---NO SE PUEDE AGREGAR PORQUE NO CUMPLE t.clasificacion == 1 && t.total > 0", t.clasificacion, t.total);
          }
        })
        this.tratamiento.descuentoPromo = montoDescPesosTxs;


      } else if (this.tratamiento.clasificacion == 1) {//en caso que sea por agrupacion OD o por kit

          const totalPlan = this.tratamiento.montoPlanDescuento==null?0:this.tratamiento.montoPlanDescuento;
          const totalVale = this.tratamiento.montoValeDescuento==null?0:this.tratamiento.montoValeDescuento;
          let totalOriginal = this.tratamiento.subtotal-(totalPlan+totalVale);

          if (this.tratamiento.promocion.descuento > 0) {
            this.tratamiento.promocion.promoDescPesos = Math.round((totalOriginal * this.tratamiento.promocion.descuento) / 100);
          } else {

            if (this.tratamiento.promocion.promoDescPesosOriginal == null) {
              this.tratamiento.promocion.promoDescPesosOriginal = this.tratamiento.promocion.promoDescPesos;
            }

            this.tratamiento.promocion.promoDescPesos = this.tratamiento.promocion.promoDescPesosOriginal * this.tratamiento.cantidadMaxima;
            console.info("--------agregarPromocion 1: ", montoDescPesosTxs, this.tratamiento.promocion.promoDescPesos, this.tratamiento.promocion.promoDescPesosOriginal, this.tratamiento.cantidadMaxima);
          }

          if (this.tratamiento.promocion.promoDescPesos > totalOriginal) {
            this.tratamiento.promocion.promoDescPesos = totalOriginal;
          }

          totalOriginal -= this.tratamiento.promocion.promoDescPesos;

          this.tratamiento.total = totalOriginal;
          this.tratamiento.inversionTotal = totalOriginal;
          this.tratamiento.descuentoPromo = this.tratamiento.promocion.promoDescPesos;

      }

      item.tratmientosDescuento.forEach(f=>{

        if(f.idTratamiento === this.tratamiento.idTratamiento) {
          if(this.tratamiento.promocion !== null){
            this.tratamiento.promocion.descuento = f.descuento;
            if (this.tratamiento.inversionTotal) {
              this.tratamiento.promocion.promoDescPesos = montoDescPesosTxs;
            }
            this.aplicarDescuentoActualizarTotal(showMsj);
          }

        }
      })

      return true;
    },

    aplicarDescuentoActualizarTotal(dioClick){
      if(this.tratamiento.idKitTratamiento != null){
        this.tratamiento.inversionTotal =  this.tratamiento.total
      }else{
        this.tratamiento.inversionTotal =  this.tratamiento.total * this.tratamiento.tratamientos.length;
      }

      this.$emit('restarPromocionAplicada',   this.tratamiento, this.agrupadoPorOd , dioClick);
    },

    visualizar(){
      this.mostrar = !this.mostrar
    },

    aplicaPromoPlan(promoTmp) {
      console.info("INICIO++++++++++++PROMO DE PLAN", promoTmp.aplicaEnPlanes);
      if (promoTmp.aplicaEnPlanes != null) {
        if (this.tratamiento.tratamientos != null) {
          const tratAct = this.tratamiento.tratamientos.find(t=>t.idTratamiento == this.tratamiento.idTratamiento); //obtengo plan del tratamiento tratamiento
          return this.calculosPromocionPlan(promoTmp, tratAct);
        } else if (this.tratamiento.clasificacion == 1) {
          console.info("AGRUP+++++++++++++PROMO DE PLAN", this.tratamiento.tratamiento, promoTmp.idPromocion, promoTmp.descuento, promoTmp.promocion+"%", promoTmp, this.tratamiento);
          return this.calculosPromocionPlan(promoTmp, this.tratamiento);
        }
      }

      if(this.tratamiento.lstCalcDesc != null && this.tratamiento.lstCalcDesc.length === 1 && this.tratamiento.lstCalcDesc[0].montoCopagoFijo != null){
        console.info("---tratamiento con copago en kit:   NO APLICAN PROMOCIONES");
        return false;
      }

      return true;
    },

    validarTrtPromoCopago(){
      if(this.tratamiento.idTipoDescuentoPlan != null && this.tratamiento.idTipoDescuentoPlan.filter(t => t === 3).length === this.tratamiento.idTipoDescuentoPlan.length){
        return false;
      }else if(this.tratamiento.lstCalcDesc != null && this.tratamiento.lstCalcDesc.length === 1 && this.tratamiento.lstCalcDesc[0].montoCopagoFijo != null){
        return false;
      }

      if(this.tratamiento.tratamientos != null && this.tratamiento.tratamientos.length === 1 && this.tratamiento.tratamientos[0].montoCopagoFijo != null && this.tratamiento.tratamientos[0].total === this.tratamiento.tratamientos[0].montoCopagoFijo){
          console.info("---los trt sin copago ya tienen descuento del 100% (1):   NO APLICA");
          return false;
      }

      return true;
    },

    validarSegmentacionPlan(tratAct, porcentajeDescuentoActualPlan, operador, valorRegla, idTipoDescuentoPlanEnPromo) {
      console.info("(validarSegmentacionPlan)-tratAct:", tratAct.tratamiento, tratAct);
      if (operador==null || valorRegla ==null) { //si es solo validacion por plan, que no valide las reglas, de lo contrario que valide los porcentajes de planes
        console.info("-------****validarSegmentacionPlan 01** OPERADOR O REGLA NULA", porcentajeDescuentoActualPlan, operador, valorRegla);
        return true;
      }

      if (porcentajeDescuentoActualPlan== null) {
        console.info("-------****validarSegmentacionPlan 02** PLAN NULO", porcentajeDescuentoActualPlan);
        return true;
      }

      let resultado = false;

      if (operador == "=") {
        resultado = porcentajeDescuentoActualPlan == valorRegla;
      } else if (operador == ">") {
        resultado = porcentajeDescuentoActualPlan > valorRegla;
      } else if (operador == "<") {
        resultado = porcentajeDescuentoActualPlan < valorRegla;
      } else if (operador == ">=") {
        resultado = porcentajeDescuentoActualPlan >= valorRegla;
      } else if (operador == "<=") {
        resultado = porcentajeDescuentoActualPlan <= valorRegla;
      }

      if(resultado && tratAct.idTipoDescuentoPlan.includes(idTipoDescuentoPlanEnPromo)){
        resultado = true;
      }else{
        resultado = false;
      }

      console.info("-------****validarSegmentacionPlan 03*** ", porcentajeDescuentoActualPlan, operador, valorRegla, resultado);
      return resultado;
    },

    esModalAplicarValido() {
      const list = this.lista;
      return list != null ? list.some(l=>!l.promocionReestringida) : list;
    },
    calculosPromocionPlan(promoTmp, tratAct){
      if (tratAct != null) {//funcion aparte
        console.info("---calculosPromocionPlan (0):   PROMO DE PLAN", tratAct.tratamiento, promoTmp.idPromocion, promoTmp.descuento, promoTmp.promocion+"%", tratAct, promoTmp, this.tratamiento);

        if(tratAct.lstCalcDesc != null && tratAct.lstCalcDesc.length === 1 && tratAct.lstCalcDesc[0].montoCopagoFijo != null){
          console.info("---trt descuento copago:   NO APLICA");
          return false;
        }

        let planesPromo = promoTmp.aplicaEnPlanes.find(pln => pln.idPlan == tratAct.idPlan);//obtengo regla de promocion por plan
        if (planesPromo === undefined) {
          if (promoTmp.aplicaEnPlanes !== null && promoTmp.aplicaEnPlanes !== undefined) {
            const planesPromo2 = promoTmp.aplicaEnPlanes.find(pln => pln.idPromocion == tratAct.idPromocion);
            if (!this.validarSegmentacionPlan(tratAct,
                tratAct.idTipoDescuentoPlan === 1 ? tratAct.porcentajePlanDescuento : tratAct.idTipoDescuentoPlan === 2 ? tratAct.montoPlanDescuento : tratAct.montoCopagoFijo,
                planesPromo2.operadorReglaPorAplicacionPlan, planesPromo2.valorReglaPorAplicacionPlan, planesPromo2.idTipoDescuentoPlan)) {
              promoTmp.promocionReestringida = true;
              console.info("---calculosPromocionPlan (1):   NO APLICA");
              return false;
            }
            planesPromo = promoTmp.aplicaEnPlanes;
          }
        }
        if(planesPromo === undefined){
          promoTmp.promocionReestringida = true;
          console.info("---calculosPromocionPlan (2):   NO APLICA");
          return false;
        }
        if (planesPromo != null) {
          promoTmp.promocionReestringida = false;
          if (this.validarSegmentacionPlan(tratAct, tratAct.porcentajePlanDescuento, planesPromo.operadorReglaPorAplicacionPlan, planesPromo.valorReglaPorAplicacionPlan, null)) {
            const planesPromo3 = promoTmp.tratmientosDescuento.find(pln => pln.idTratamiento == tratAct.idTratamiento);
            if(tratAct.montoCopagoFijo != null && tratAct.montoCopagoFijo === tratAct.total){
              console.info("---los trt sin copago ya tienen descuento del 100% (2):   NO APLICA");
              return false;
            }
            if (planesPromo3 != null) {
              promoTmp.promocionReestringida = false;
              console.info("---calculosPromocionPlan (3):   SI APLICA");
              return true;
            }
            console.info("---calculosPromocionPlan (4):   NO APLICA");
            promoTmp.promocionReestringida = true;
            return false;
          }
        } else {
          const lstPlanesPromoSeg = promoTmp.aplicaEnPlanes.filter(pln => pln.idPlan == null);//obtengo regla de promocion para segmentacion
          for (let i=0; i < lstPlanesPromoSeg.length; i++) {
            promoTmp.promocionReestringida = !this.validarSegmentacionPlan(tratAct, tratAct.porcentajePlanDescuento,
                lstPlanesPromoSeg[i].operadorReglaPorAplicacionPlan, lstPlanesPromoSeg[i].valorReglaPorAplicacionPlan, null)
            if (!promoTmp.promocionReestringida) {
              console.info("---calculosPromocionPlan (5):   SI APLICA");
              promoTmp.promocionReestringida = false;
              return true;
            }
          }
        }

        console.info("---calculosPromocionPlan (7):   NO APLICA");
        promoTmp.promocionReestringida = true;
        return false;
      }
    }

  },

  computed: {
    lista() {
      let promos = this.promociones.filter( value =>value.tratmientosDescuento.some( it => it['idTratamiento'] === this.tratamiento.idTratamiento))
      promos.forEach(p => {
        if(p.promocionForzosa){
          if (this.agregarPromocion(p, false)) {
            return null;
          }
        } else {
          let aplicaPromocion = this.aplicaPromoPlan(p); //se manda a validación para desactivar select
          return aplicaPromocion;
        }
      })

      if(!this.validarTrtPromoCopago()){
        console.info("---tratamiento con copago:   NO APLICAN PROMOCIONES");
        return null;
      }

      return promos;
    },
  },
}
</script>

<style scoped>
.bodyTxt{
  font-size: .8em;
  color: #747474;
}
.zoom {
  font-size: 18px;
  transition: transform .2s; /* Animation */
  margin: 0 auto;
  color: #8DBEE2;
}
.zoom:hover {
  color: gray;
  transform: scale(1.5);
}
.bordePromo {
  min-height: 3em;
  margin-left: 0.5em;
  margin-right: 0.5em;
  border: 1px solid rgba(194, 194, 194, 0.36);
  display: flex;
  z-index: 10;
  position: relative;
  background: white;
  padding: 5px;
  min-width: 100px;
}
.centrado {
  text-align: left;
  align-items: center;
  margin-left: 0px ;
  margin-top: auto ;
  margin-bottom: auto ;
  vertical-align: center;
  padding: 0px !important;
}
.pulsate-fwd {
  -webkit-animation: pulsate-fwd 0.5s ease-in-out infinite both;
  animation: pulsate-fwd 0.5s ease-in-out infinite both;
}

/* ----------------------------------------------
 * Generated by Animista on 2022-2-21 13:11:57
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation pulsate-fwd
 * ----------------------------------------
 */
@-webkit-keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}
@keyframes pulsate-fwd {
  0% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
  50% {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
  100% {
    -webkit-transform: scale(1);
    transform: scale(1);
  }
}

.esquina {
  position: absolute;
  top: 33%;
  right: 0%;
}

</style>
